import PlaceType from '@/assets/enums/config/PlaceType'

// Domicile et lieu de décès sont proposés comme lieu de livraison
// (SelectDossierPlace.vue) sans jamais correspondre à une Location réelle
// (id: null) : ni la relation delivery_place, ni le libellé libre
// delivery_place_other ne portent alors de nom une fois enregistrés, seule
// l'adresse (rue/code postal/ville) l'est. Sans ce mapping, l'affichage du
// lieu de livraison restait vide au-dessus de l'adresse.
const PSEUDO_PLACE_NAME_KEYS = {
  [PlaceType.DOMICILE]: 'attributes.DOM',
  [PlaceType.LIEU_DECES]: 'attributes.death_place'
}

export function pseudoPlaceNameKey(placeKind) {
  return PSEUDO_PLACE_NAME_KEYS[placeKind] ?? null
}
